<template>
    <div class="system-index">
        <div class="table-content">
            <div class="calendar-config">
              <div class="select">
                <el-select size="small" v-model="calendarMonth" @change="changeMonth()" style="margin-right:21%">
                  <el-option v-for="item in monthList" :value="item.value" :label="item.name" :key="item.value"></el-option>
                </el-select>
                <el-select size="small" v-model="calendarYear" @change="changeYear()">
                  <el-option v-for="item in yearList" :value="item.value" :label="item.name" :key="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div style="width: 100%;background-color: white;padding-bottom: 20px">
             <div class="calendar">
              <div class="calendar_header">
                <div><span>Sun</span></div>
                <div><span>Mon</span></div>
                <div><span>Tue</span></div>
                <div><span>Wed</span></div>
                <div><span>Thu</span></div>
                <div><span>Fri</span></div>
                <div><span>Sat</span></div>
              </div>
              <div class="calendar_body">
                <div class="body_item" v-for="(item,index) in calendarData" :key="index">
                  <div v-if="isNow===1">
                      <div v-if="index<42&&index>=week&&index<week+monthLenth" class="upMonth">
                        <div v-if="index>=week&&(index-week)<monthLenth" class="fontSize">
                           {{index-week+1}}
                        </div>
                        <div v-if="item.newCooperative.length>0||item.newLiveCourse.length>0||item.newRemoteList.length>0" class="alerDiv">
                            <div class="alert" v-for="(remote,i) in item.newRemoteList" :key="i+'a'"><router-link :to="{path:'/remote',query:{id:remote.id}}">{{remote.diagnosisDate | date}} {{remote.name}}</router-link></div>
                            <div class="alert" v-for="(live,j) in item.newLiveCourse" :key="j+'b'"><router-link :to="{path:'/live',query:{id:live.id}}">{{live.lectureTime | date}} {{live.name}}</router-link></div>
                            <div class="alert" v-for="(cooperation,k) in item.newCooperative" :key="k+'c'"><router-link :to="{path:'/cooperation',query:{id:cooperation.id}}">{{cooperation.firstDate | date}} {{cooperation.name}}</router-link></div>
                        </div>
                      </div>
                  </div>
                  <div v-else-if="isNow===2" class="nowMonth">
                    <div v-if="index+1<(today+week)&&index>=week" class="upMonth">
                      <div v-if="index>=week&&(index-week)<monthLenth" class="fontSize">{{index-week+1}}</div>
                      <div v-if="item.newCooperative.length>0||item.newLiveCourse.length>0||item.newRemoteList.length>0" class="alerDiv">
                        <div class="alert" v-for="(remote,i) in item.newRemoteList" :key="i+'a'"><router-link :to="{path:'/remote',query:{id:remote.id}}">{{remote.diagnosisDate | date}} {{remote.name}}</router-link></div>
                        <div class="alert" v-for="(live,j) in item.newLiveCourse" :key="j+'b'"><router-link :to="{path:'/live',query:{id:live.id}}">{{live.lectureTime | date}} {{live.name}}</router-link></div>
                        <div class="alert" v-for="(cooperation,k) in item.newCooperative" :key="k+'c'"><router-link :to="{path:'/cooperation',query:{id:cooperation.id}}">{{cooperation.firstDate | date}} {{cooperation.name}}</router-link></div>
                      </div>
                    </div>
                    <div v-else-if="index+1===(today+week)" style="width: 100%;height: 10vh;border-radius: 5px;background-color: #ef5350;box-shadow:  5px 5px 5px #888888">
                      <div v-if="index>=week&&(index-week)<monthLenth" style="color:white;font-size: 20px;text-align: center">{{index-week+1}}</div>
                      <div v-if="item.newCooperative.length>0||item.newLiveCourse.length>0||item.newRemoteList.length>0" class="alerDiv">
                        <div class="alert" v-for="(remote,i) in item.newRemoteList" :key="i+'a'"><router-link :to="{path:'/remote',query:{id:remote.id}}">{{remote.diagnosisDate | date}} {{remote.name}}</router-link></div>
                        <div class="alert" v-for="(live,j) in item.newLiveCourse" :key="j+'b'"><router-link :to="{path:'/live',query:{id:live.id}}">{{live.lectureTime | date}} {{live.name}}</router-link></div>
                        <div class="alert" v-for="(cooperation,k) in item.newCooperative" :key="k+'c'"><router-link :to="{path:'/cooperation',query:{id:cooperation.id}}">{{cooperation.firstDate | date}} {{cooperation.name}}</router-link></div>
                      </div>
                    </div>
                    <div v-else-if="index+1>(today+week)&&index<week+monthLenth" style="width: 100%;height: 10vh;border-radius: 5px;background-color: #69f0ae">
                      <div v-if="index>=week&&(index-week)<monthLenth" style="color:white;font-size: 20px;text-align: center">{{index-week+1}}</div>
                      <div v-if="item.newCooperative.length>0||item.newLiveCourse.length>0||item.newRemoteList.length>0" class="alerDiv">
                        <div class="alert" v-for="(remote,i) in item.newRemoteList" :key="i+'a'"><router-link :to="{path:'/remote',query:{id:remote.id}}">{{remote.diagnosisDate | date}} {{remote.name}}</router-link></div>
                        <div class="alert" v-for="(live,j) in item.newLiveCourse" :key="j+'b'"><router-link :to="{path:'/live',query:{id:live.id}}">{{live.lectureTime | date}} {{live.name}}</router-link></div>
                        <div class="alert" v-for="(cooperation,k) in item.newCooperative" :key="k+'c'"><router-link :to="{path:'/cooperation',query:{id:cooperation.id}}">{{cooperation.firstDate | date}} {{cooperation.name}}</router-link></div>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="isNow===3" class="downMonth">
                    <div v-if="index<42&&index>=week&&index<week+monthLenth" style="width: 100%;height: 10vh;border-radius: 5px;background-color: #69f0ae">
                      <div v-if="index>=week&&(index-week)<monthLenth" style="color:white;font-size: 20px;text-align: center">{{index-week+1}}</div>
                      <div v-if="item.newCooperative.length>0||item.newLiveCourse.length>0||item.newRemoteList.length>0" class="alerDiv">
                        <div class="alert" v-for="(remote,i) in item.newRemoteList" :key="i+'a'"><router-link :to="{path:'/remote',query:{id:remote.id}}">{{remote.diagnosisDate | date}} {{remote.name}}</router-link></div>
                        <div class="alert" v-for="(live,j) in item.newLiveCourse" :key="j+'b'"><router-link :to="{path:'/live',query:{id:live.id}}">{{live.lectureTime | date}} {{live.name}}</router-link></div>
                        <div class="alert" v-for="(cooperation,k) in item.newCooperative" :key="k+'c'"><router-link :to="{path:'/cooperation',query:{id:cooperation.id}}">{{cooperation.firstDate | date}} {{cooperation.name}}</router-link></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
  import moment from 'moment'
export default {
    data () {
        return {
            radio3: 1,
            calendarYear: '',
            calendarMonth: '',
            yearList: [],
            monthList: [],
            selectDate: new Date(),
            infoShow: false,
            infoClass: 'infomation',
            flag: false,
            calendarData:[],
            week:0, //周几
            monthLenth:0, //每个月多少天
            today:0,
            isNow:2  //1：过去 2：当月 3：将来
        }
    },
    methods: {
        onShow() {
          document.querySelector('.popper__arrow').className = 'popper__arrow red'
        },
        selectInit () {
            for(var i = 0;i<=11;i++){
                this.monthList.push({value:i+1,name:i + 1 +'月'})
            }
            for(var i = this.selectDate.getFullYear()-20;i<=this.selectDate.getFullYear()+20;i++){
                this.yearList.push({value:i,name:i+'年'})
            }
            this.calendarYear = this.selectDate.getFullYear()
            this.calendarMonth = this.selectDate.getMonth()+1
        },
        changeMonth(){
          this.getInfo()
          this.isNowDate()
        },
        changeYear(){
          this.getInfo()
          this.isNowDate()
        },
        isNowDate(){
          var myDate = new Date()
          if(parseInt(this.calendarYear)>myDate.getFullYear()){
            this.isNow=3
          }else if(parseInt(this.calendarYear)<myDate.getFullYear()){
            this.isNow=1
          }else if(parseInt(this.calendarMonth)>myDate.getMonth()+1){
            this.isNow=3
          }else if(parseInt(this.calendarMonth)<myDate.getMonth()+1){
            this.isNow=1
          }else{
            this.isNow=2
          }
        },
        getInfo(){
          var myDate = new Date()
          this.today=myDate.getDate()
          this.calendarData=[]
          this.Axios.get("/api/Home/GetHomeInfo?year="+this.calendarYear+"&month="+this.calendarMonth).then(res=>{
            if(res.data.status===100){
              // console.log('系统首页', res.data)
              this.calendarData = res.data.data.list
              // console.log('calendarData', this.calendarData)
              this.week=res.data.data.week
              this.monthLenth=res.data.data.list.length
              for(let i=0;i<this.week;i++){
                this.calendarData.unshift({newCooperative:[],newLiveCourse:[],newRemoteList:[]})
              }
              const cha = 42-this.calendarData.length
              for(let j=0;j<cha;j++){
                this.calendarData.push({newCooperative:[],newLiveCourse:[],newRemoteList:[]})
              }
            }
          }).catch(error=>{
            this.$message({
              showClose: true,
              message: '网络错误，联系管理员',
              type: 'error'
            });
          })
        }
    },
    created(){
      this.selectInit()
      this.getInfo()
    },
    // mounted() {
    //   this.$nextTick(() => {
    //     console.log(this.$refs.ssPopover)
    //   })
    // },
    filters: {
      date(value) {
        value = moment(value).format('HH:mm')
        return value
      }
    }
}
</script>

<style scoped lang="less">
  .alerDiv {
    height: 70%;
    width: 100%;
    font-size: 12px;
    overflow-y: auto
  }
  .alerDiv::-webkit-scrollbar{
    display: none;
  }
  .alert {
    background-color: white;
    padding: 2px;
    /*border-radius: 2px;*/
    margin:1px
  }
  .fontSize {
    font-size: 20px;
    color: gainsboro;
    width: 100%;
    text-align: center;
  }
  .upMonth {
    width: 100%;
    border-radius: 5px;
    background-color: #f4f4f5;
    height: 10vh;
    max-height: 90px;
    min-height: 62px;
    margin-bottom: 8px;
    position: relative;
  }
  .el-popper[x-placement^=top] .red.popper__arrow::after {
    border-top-color: red !important;
    content: ' ';
    display: block;
    height: 0;
    width: 0;
    border-width: 6px;
  }
    .system-index{
          .table-content{
            padding: 25px !important;
          }
          .calendar{
            background-color: white;
            padding-top: 20px;
            width: 60%;
            margin: 0 auto;
            .calendar_header{
              display: flex;
              justify-content: space-around;
              font-weight: bold;
              z-index: -10000;
              color: #6f7180;
            }
            .calendar_body{
              padding-top: 50px;
              z-index: 10000;
              display: flex;
              justify-content: space-around;
              flex-wrap:wrap;
              .body_item{
                flex-basis: 13%;
                height: 10vh;
                max-height: 90px;
                min-height: 62px;
                margin-bottom: 8px;
              }
            }
          }
        .breadcrumb{
            overflow:hidden;
            span,.el-breadcrumb{
                float:left;
            }
            span{
                font-size:14px;
                color:#666;
                line-height:1;
            }
        }
        .table-content{
          // width: 100%;
            .calendar-config{
                background:#fff;
                .select {
                  overflow: hidden;
                  padding-top: 20px;
                }
                // padding:40px 300px;
                // width: 100%;
                .el-radio-group{
                    float:right;
                }
                .el-select{
                    width:100px;
                    float:right;
                    margin-right:20px;
                }
            }
            #calendar{
                background:#fff;
            }
            #calendar {
                //  消除默认边框
                /deep/ .fc-head, /deep/ .fc-head-container, /deep/ .fc-day-header, /deep/ .fc-body, /deep/ .fc-row, /deep/ .fc-row tbody, /deep/ .fc-day{
                    border-color:#fff;
                }
                //  头部高度，对齐方式
                /deep/ .fc-day-header {
                    height:70px;
                    text-align:right;
                }
                //  日历字体
                /deep/ .fc-day-header, /deep/ .fc-day{
                    position:relative;
                    padding-right:20px;
                    font-size:14px;
                    color:rgba(0,0,0,0.65);
                }
                //  日历主体文字位置偏移
                /deep/ .fc-day-top{
                    padding:10px 20px;
                    font-size:14px;
                    color:rgba(0,0,0,0.65);
                }
                //  日历底边
                /deep/ .fc-day:before {
                    content:' ';
                    height:4px;
                    width:90%;
                    position:absolute;
                    top:0px;
                    left:0;
                    right:0;
                    margin:0 auto;
                    background:#e9e9e9;
                }
                //  防止鼠标滑动过程中移到该元素上
                /deep/ .fc-content-skeleton{
                    height:0;
                }
            }
            a{
                color: #222
            }
        }
        .information{
            width:155px;
            min-height:109px;
            position:fixed;
            top:0;
            left:0;
            border-radius:5px !important;
            list-style:none;
            padding:10px;
            z-index:2;
            li{
                padding-top:25px;
            }
            li:first-child{
                padding-top:0;
            }
        }
        .green{
            background:#A5F24C;
        }
        .red{
            background:#FF4081;
        }
        .gary{
            background:#e5e5e5;
        }
        .green:before,.red:before,.gary:before{
            content:' ';
            width:15px;
            height:15px;
            position:absolute;
            bottom:-8px;
            left:15px;
            transform:rotate(45deg);
        }
        .green:before{
            background:#A5F24C;
        }
        .red:before{
            background:#FF4081;
        }
        .gary:before{
            background:#e5e5e5;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/SystemIndex/SystemIndex.vue